import React, { useEffect, useState } from "react";
import close from "../../../assets/icons/close.svg";
import next from "../../../assets/icons/icon.svg";
import { getData, patchData, Postdata, UpdateDataFormWithJson } from "../../../API/GlobalApi";

import Notifier from "../../../Utils/notify";
import SpinnerLoader from "../../../Utils/Spinner";

export const EditContsetDetails = ({
    isOpen,
    onClose,
    selectedParticipants,
    getActivityDatas,
    currentPage,
    filterQueryString,
    searchValue,
    sortOrder,
    modalOpenQueryRef,
    setselectedStudent,
    sortField,
    setRefreshKey
}) => {

    const [formData, setFormData] = useState({
        arct_roll_number: "",
        name: "",
        father_name: "",
        previous_institution: "",
        mobile: "",
        aadhar: "",
    });


    useEffect(() => {
        if (selectedParticipants) {
            setFormData({
                arct_roll_number: selectedParticipants.arct_roll_number || "",
                name: selectedParticipants.name || "",
                father_name: selectedParticipants.father_name || "",
                previous_institution: selectedParticipants.previous_institution || "",
                mobile: selectedParticipants.mobile || "",
                aadhar: selectedParticipants.aadhar || "",
            });
        }
    }, [selectedParticipants]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const payload = {
                name: formData.name,
                father_name: formData.father_name,
                previous_institution: formData.previous_institution,
                mobile: formData.mobile,
                aadhar: formData.aadhar,
                arct_roll_number: formData.arct_roll_number
            };

            const res = await patchData(
                `administration/contests/2/participants/${selectedParticipants.id}/`,
                payload
            );

            // If API returns error array
            if (res?.error?.length) {
                Notifier.error(res.error.join(", ")); // join multiple errors if any

                return; // stop further execution
            }

            // if (res?.error) {
            //     let errorMessages = [];

            //     // Case 1: error is an array
            //     if (Array.isArray(res.error)) {
            //         errorMessages = res.error;
            //     }

            //     // Case 2: error is an object (field-wise errors)
            //     else if (typeof res.error === "object") {
            //         errorMessages = Object.values(res.error).flat();
            //     }

            //     if (errorMessages.length) {
            //         Notifier.error(errorMessages.join(", "));
            //         return;
            //     }
            // }
            Notifier.success("Details updated successfully");
            setRefreshKey(prev => prev + 1)
            onClose();
        } catch (error) {
            console.error(error);
            Notifier.error("Failed to update details");
        } finally {
            setLoading(false);
        }
    };



    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content recevingPaymentBody" style={{
                position: 'relative',
                width: '90%',           // responsive width
                maxWidth: '700px',      // max width for larger screens
                display: 'flex',
                flexDirection: 'column',
                overflowY: 'auto',
                maxHeight: '80vh',      // responsive max height
                padding: '25px',
                borderRadius: '8px',
                background: '#fff',
            }}>
                <div
                    className="modal-header-content"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                    }}
                >
                    <h2 className="text-primary">
                        Edit Details
                    </h2>
                    <button className="close-btn" onClick={onClose}>
                        <img src={close} alt="close" />
                    </button>
                </div>

                <div className="row mt-2">
                    <div className="col-md-6">
                        <label className="form-labell">
                            Form No <span className="astrisk">*</span>
                        </label>
                        <input
                            type="text"
                            className="fm-modal form-control"
                            name="arct_roll_number"
                            value={formData.arct_roll_number}
                            onChange={handleChange}
                            placeholder="Enter Form Number"
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-labell">
                            Name <span className="astrisk">*</span>
                        </label>
                        <input
                            type="text"
                            className="fm-modal form-control"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter Name"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-labell">
                            Father Name <span className="astrisk">*</span>
                        </label>
                        <input
                            type="text"
                            className="fm-modal form-control"
                            name="father_name"
                            value={formData.father_name}
                            onChange={handleChange}
                            placeholder="Enter Father Name"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-labell">
                            Previous Institution
                        </label>
                        <input
                            type="text"
                            className="fm-modal form-control"
                            name="previous_institution"
                            value={formData.previous_institution}
                            onChange={handleChange}
                            placeholder="Enter Institution"
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-labell">
                            Mobile Number <span className="astrisk">*</span>
                        </label>
                        <input
                            type="text"
                            className="fm-modal form-control"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleChange}
                            placeholder="Enter Mobile Number"
                            maxLength={10}
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-labell">
                            Aadhar Number
                        </label>
                        <input
                            type="text"
                            className="fm-modal form-control"
                            name="aadhar"
                            value={formData.aadhar}
                            onChange={handleChange}
                            placeholder="Enter Aadhar Number"
                            maxLength={12}
                        />
                    </div>
                </div>
                {/* <div className="row">
                    <div className="col-md-6">
                        <label className="form-labell">
                            Aadhar Number
                        </label>
                        <input
                            type="text"
                            className="fm-modal form-control"
                            name="aadhar"
                            value={formData.aadhar}
                            onChange={handleChange}
                            placeholder="Enter Aadhar Number"
                            maxLength={12}
                        />
                    </div>
                </div>  */}
                <div className="row mt-4">
                    <div className="col-md-12 d-flex justify-content-end">
                        <button className="add-btn" onClick={handleSubmit}>
                            {loading ? <span className="spinner-border spinner-border-sm" role="status" /> : "Update Details"}
                            <img className="ms-2" src={next} alt="next" />
                        </button>

                    </div>
                </div>
            </div>
        </div>
    );
};
